import { render, staticRenderFns } from "./OrderTables.vue?vue&type=template&id=3875c9d0&"
import script from "./OrderTables.vue?vue&type=script&lang=js&"
export * from "./OrderTables.vue?vue&type=script&lang=js&"
import style0 from "./OrderTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports